import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cancelEditNote } from '../../actions/favoriteEntities/notes';
import { CancelButton, ICancelButtonProps } from '../../components/CancelButton';
import { TThunkDispatch } from '../../types/redux';

type TCancelButtonProps = Pick<ICancelButtonProps, 'entityId'>;

function mapDispatchToProps(dispatch: TThunkDispatch, { entityId }: TCancelButtonProps) {
  return {
    onClick: bindActionCreators(() => cancelEditNote(entityId), dispatch),
  };
}

export const CancelCommentContainer = connect(undefined, mapDispatchToProps)(CancelButton);
